export interface IApiEndpointProvider {
  createCustomerAccount: string;
  createOnlineOrder: string;
  markOrderWithFailedPayment: string;
  abortOrder: string;
  lockClientSeatSelection: string,
  createPoiReview: string,
  createClientFromCustomerAccount: string,
  confirmAddToCart: string,
  confirmInitiateCheckout: string,
  confirmCompleteRegistration: string,
  confirmInitiatePurchase: string,
  confirmPurchaseComplete: string,
  confirmViewContent: string,
  confirmPageView: string,
  confirmSearch: string,
  validateTaxForm: string,
  fetchArtistPageInfo: string;
  fetchBrandPageInfo: string;
  fetchOrganizerPageInfo: string;
  fetchTicketSupplementTemplates: string;
  fetchProductDescription: string;
  fetchPoliciesSettings: string;
  fetchRegistrationSettings: string;
  fetchNfcPassPageInfo: string;
  fetchBusinessLevelMarketingInfo: string;
  fetchBusinessLevelMarketingSubscriber: string;
  unlockPromoTicket: string;
  validateOrderForDownload: string;
  downloadTicket: string;
  downloadTicketSupplement: string;
  downloadInvoice: string;
  fetchFlexiblePass: string;
  sanitizeGenericVoucherCart: string;
  fetchCheckoutDiscountCodes: string;
}

export const ApiEndpointProvider: IApiEndpointProvider = {
  createCustomerAccount: 'createCustomerAccount',
  createOnlineOrder: 'createOnlineOrder',
  markOrderWithFailedPayment: 'markOrderWithFailedPayment',
  abortOrder: 'abortOrder',
  lockClientSeatSelection: 'lockClientSeatSelection',
  createPoiReview: 'createPoiReview',
  createClientFromCustomerAccount: 'createClientFromCustomerAccount',
  confirmAddToCart: 'confirmAddToCart',
  confirmInitiateCheckout: 'confirmInitiateCheckout',
  confirmCompleteRegistration: 'confirmCompleteRegistration',
  confirmInitiatePurchase: 'confirmInitiatePurchase',
  confirmPurchaseComplete: 'confirmPurchaseComplete',
  confirmViewContent: 'confirmViewContent',
  confirmPageView: 'confirmPageView',
  confirmSearch: 'confirmSearch',
  validateTaxForm: 'validateTaxForm',
  fetchArtistPageInfo: 'fetchArtistPageInfo',
  fetchBrandPageInfo: 'fetchBrandPageInfo',
  fetchOrganizerPageInfo: 'fetchOrganizerPageInfo',
  fetchTicketSupplementTemplates: 'fetchTicketSupplementTemplates',
  fetchProductDescription: 'fetchProductDescription',
  fetchPoliciesSettings: 'fetchPoliciesSettings',
  fetchRegistrationSettings: 'fetchRegistrationSettings',
  fetchNfcPassPageInfo: 'fetchNfcPassPageInfo',
  fetchBusinessLevelMarketingInfo: 'fetchBusinessLevelMarketingInfo',
  fetchBusinessLevelMarketingSubscriber: 'fetchBusinessLevelMarketingSubscriber',
  unlockPromoTicket: 'unlockPromoTicket',
  validateOrderForDownload: 'validateOrderForDownload',
  downloadTicket: 'downloadTicket',
  downloadTicketSupplement: 'downloadTicketSupplement',
  downloadInvoice: 'downloadInvoice',
  fetchFlexiblePass: 'fetchFlexiblePass',
  sanitizeGenericVoucherCart: 'sanitizeGenericVoucherCart',
  fetchCheckoutDiscountCodes: 'fetchCheckoutDiscountCodes',
};

export const EmulatorApiEndpointProvider: IApiEndpointProvider = {
  createCustomerAccount: 'accounts/createCustomerAccount',
  createOnlineOrder: 'orders/createOnlineOrder',
  markOrderWithFailedPayment: 'orders/markOrderWithFailedPayment',
  abortOrder: 'orders/abortOrder',
  lockClientSeatSelection: 'events/lockClientSeatSelection',
  createPoiReview: 'reviews/createPoiReview',
  createClientFromCustomerAccount: 'accounts/createClientFromCustomerAccount',
  confirmAddToCart: 'analytics/trackAddToCart',
  confirmInitiateCheckout: 'analytics/trackInitiateCheckout',
  confirmCompleteRegistration: 'analytics/trackCompleteRegistration',
  confirmInitiatePurchase: 'analytics/trackInitiatePurchase',
  confirmPurchaseComplete: 'analytics/trackPurchaseComplete',
  confirmViewContent: 'analytics/trackViewContent',
  confirmPageView: 'analytics/trackPageView',
  confirmSearch: 'analytics/trackSearch',
  validateTaxForm: 'orders/validateTaxForm',
  fetchArtistPageInfo: 'public/fetchArtistPageInfo',
  fetchBrandPageInfo: 'public/fetchBrandPageInfo',
  fetchOrganizerPageInfo: 'public/fetchOrganizerPageInfo',
  fetchTicketSupplementTemplates: 'public/fetchTicketSupplementTemplates',
  fetchProductDescription: 'business/fetchProductDescription',
  fetchPoliciesSettings: 'business/fetchPoliciesSettings',
  fetchRegistrationSettings: 'public/fetchRegistrationSettings',
  fetchNfcPassPageInfo: 'passes/fetchNfcPassPageInfo',
  fetchBusinessLevelMarketingInfo: 'marketing/fetchBusinessLevelMarketingInfo',
  fetchBusinessLevelMarketingSubscriber: 'marketing/fetchBusinessLevelMarketingSubscriber',
  unlockPromoTicket: 'promo/unlockPromoTicket',
  validateOrderForDownload: 'download/validateOrderForDownload',
  downloadTicket: 'download/ticket',
  downloadTicketSupplement: 'download/ticketSupplement',
  downloadInvoice: 'download/invoice',
  fetchFlexiblePass: 'passes/fetchFlexiblePass',
  sanitizeGenericVoucherCart: 'dev/sanitizeGenericVoucherCart',
  fetchCheckoutDiscountCodes: 'public/fetchCheckoutDiscountCodes',
};
